import builder from '../builder';
import LoveIt from '../../streamline-icons/light/love-it.svg';

export default builder('IconLoveItLight', LoveIt);
